export default __webpack_public_path__ + "static/media/Create.ddf49f0d.jpg";